import {
  getGameModeComboboxOptions,
  getGameModeSelectOptions
} from '@bo-utils/gameModes';
import { useGetGameModesQuery } from '@bo-services/gameModesApi';
import { useMemo } from 'react';

export const useGameModes = ({
  isFullDuration
}: {
  isFullDuration?: boolean;
}) => {
  const { data, isError, isFetching, isLoading } = useGetGameModesQuery();

  const { gameModesData, isGameModesError, isLoadingGameModes } = useMemo(
    () => ({
      gameModesData: data ?? [],
      isGameModesError: isError,
      isLoadingGameModes: isFetching || isLoading
    }),
    [data, isError, isFetching, isLoading]
  );

  const { gameModeComboboxOptions, gameModeSelectOptions } = useMemo(
    () => ({
      gameModeComboboxOptions: getGameModeComboboxOptions(data, isFullDuration),
      gameModeSelectOptions: getGameModeSelectOptions(data)
    }),
    [data, isFullDuration]
  );

  return {
    gameModeComboboxOptions,
    gameModeSelectOptions,
    gameModesData,
    isGameModesError,
    isLoadingGameModes
  };
};
